import { render, staticRenderFns } from "./NotificationsTalentInterestedListItem.vue?vue&type=template&id=7bc89bbd&scoped=true&"
import script from "./NotificationsTalentInterestedListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTalentInterestedListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsTalentInterestedListItem.vue?vue&type=style&index=0&id=7bc89bbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc89bbd",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsTalentInterestedListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports